import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers } from './app.reducer';
import { CombinedListStoreEffects } from './combined-list/combined-list.effects';
import { DashboardingStoreEffects } from './dashboarding/dashboarding.effects';

@NgModule({
    imports: [
        StoreModule.forRoot(reducers, {
            runtimeChecks: {
                strictStateImmutability: true
            }
        }),
        EffectsModule.forRoot([
            DashboardingStoreEffects,
            CombinedListStoreEffects
        ]),
        StoreDevtoolsModule.instrument({
            maxAge: 50
        })
    ],
    exports: [StoreModule, EffectsModule],
    declarations: [],
    providers: []
})
export class AppStoreModule {}
